import React, { useEffect, useMemo } from 'react'
import getUrl from 'libraries/front-end-core/core/url'
import { replaceUrl } from 'libraries/front-end-core/core/history'
import useObservable from 'libraries/front-end-core/hooks/useObservable'
import { RESPONSE_PENDING } from 'libraries/front-end-core/constants/responses'
import Main from 'pages/smartsearch/Main'
import ResponseConsumer from 'components/shared/ResponseConsumer'
import RelatedQaSkeleton from 'components/smartsearch/RelatedQaSkeleton'
import { SEARCH } from 'constants/controllers'
import { useDispatch } from 'react-redux'
import { setSmartSearchEnabled } from 'redux/actions'
import { of } from 'rxjs'
import { getSmartSearchResults } from 'services/SearchService'

const SmartSearchDataSubscriber = props => {
  const dispatch = useDispatch()
  const {
    setCurrentSearchPhrase,
    queryString,
    hasSmartFeatures,
    isLogged,
    caseFlag,
    flavour,
    query = {}
  } = props

  useEffect(() => {
    setCurrentSearchPhrase(queryString)
  }, [setCurrentSearchPhrase, queryString])

  useEffect(() => {
    // If not logged in, always redirect
    if (isLogged === false) {
      replaceUrl(getUrl(
        SEARCH,
        { aol: props.aol, searchType: 'qa', flavour: props.flavour },
        { q: props.queryString }
      ))
      return
    }

    // Wait for smart features to load
    if (hasSmartFeatures === undefined) return

    // If loaded and not enabled, redirect and update state
    if (!hasSmartFeatures) {
      dispatch(setSmartSearchEnabled(false))
      replaceUrl(getUrl(
        SEARCH,
        { aol: props.aol, searchType: 'qa', flavour: props.flavour },
        { q: props.queryString }
      ))
    }
  }, [isLogged, hasSmartFeatures, props.aol, props.flavour, props.queryString, dispatch])

  const response$ = useMemo(() => {
    if (hasSmartFeatures !== true || isLogged !== true) return of(RESPONSE_PENDING)
    const selectedAols = query.aol
      ? [].concat(query.aol).map(aol => aol.toLowerCase())
      : []
    return getSmartSearchResults({
      queryString,
      smartSearchEnabled: true,
      selectedAols,
      caseFlag,
      flavour
    })
  }, [hasSmartFeatures, isLogged, queryString, caseFlag, flavour, JSON.stringify(query)])

  const smartSearchData = useObservable(response$, RESPONSE_PENDING, [response$])

  return (
    <ResponseConsumer
      response={smartSearchData}
      content={() => <Main {...props} smartSearchData={smartSearchData} />}
      pendingComponent={() => <RelatedQaSkeleton />}
    />
  )
}

export default SmartSearchDataSubscriber
